export const PROJECT_SELECTION_CHANGED_EVENT = "project-selection-changed";

export type ProjectSelectionChangedDetail = {
  selectedProjects: string[];
  path: string;
};

type ProjectSelectionRef = {
  current: string[];
};

type NotifyProjectSelectionChangedOptions = {
  previousSelectionRef: ProjectSelectionRef;
  selectedProjects: string[];
  pathname: string;
  eventTarget?: EventTarget;
};

export const hasProjectSelectionChanged = (
  previousSelection: readonly string[],
  selectedProjects: readonly string[],
) =>
  previousSelection.length !== selectedProjects.length ||
  previousSelection.some(
    (project, index) => project !== selectedProjects[index],
  );

/**
 * Notifies listeners when a caller's normalized project selection changes.
 * The caller supplies its router-specific pathname and owns normalization.
 */
export const notifyProjectSelectionChanged = ({
  previousSelectionRef,
  selectedProjects,
  pathname,
  eventTarget = window,
}: NotifyProjectSelectionChangedOptions) => {
  if (
    !hasProjectSelectionChanged(
      previousSelectionRef.current,
      selectedProjects,
    )
  ) {
    return false;
  }

  // Preserve the legacy ordering: update the comparison state before dispatch.
  previousSelectionRef.current = selectedProjects;
  eventTarget.dispatchEvent(
    new CustomEvent<ProjectSelectionChangedDetail>(
      PROJECT_SELECTION_CHANGED_EVENT,
      {
        detail: {
          selectedProjects,
          path: pathname,
        },
      },
    ),
  );

  return true;
};
